export default {
  items: [
    {
      title: 'Tasks',
      id: 'Tasks',
      to: null,
      icon: 'icon',
      sortOrder: 10,
      expanded: true,
      children: [
        {
          title: 'Tasks',
          to: { name : 'TasksIndexPage'},
          icon: 'user',
          sortOrder: 10,
        }
      ]
    }
  ]
}
